{
  "gridSize": 10,
  "maxTurns": 200,
  "runs": 600,
  "dangerWeight": 0.1,
  "undeadReviveChance": 0.625,
  "statusWeight": 1
}
